import React from 'react'
import _ from 'lodash/fp'
import { VictoryPie } from 'victory'
import colors from '@fe/ui/colors'
import { getDiffColor } from './util'

const calculateData = shotDiffs => {
  const data = [{
    x: '>2',
    y: _.size(_.filter(_.gt.convert({ rearg: true })(2), shotDiffs)),
    fill: getDiffColor(3)
  }, {
    x: '+2',
    y: _.size(_.filter(_.isEqual(2), shotDiffs)),
    fill: getDiffColor(2)
  }, {
    x: '+1',
    y: _.size(_.filter(_.isEqual(1), shotDiffs)),
    fill: getDiffColor(1)
  }, {
    x: 'Par',
    y: _.size(_.filter(_.isEqual(0), shotDiffs)),
    fill: getDiffColor(0),
    fontSize: 11
  }, {
    x: '-1',
    y: _.size(_.filter(_.isEqual(-1), shotDiffs)),
    fill: getDiffColor(-1)
  }, {
    x: '-2',
    y: _.size(_.filter(_.isEqual(-2), shotDiffs)),
    fill: getDiffColor(-2)
  }, {
    x: '-3',
    y: _.size(_.filter(_.isEqual(-3), shotDiffs)),
    fill: getDiffColor(-3)
  }, {
    x: '-4',
    y: _.size(_.filter(_.lt.convert({ rearg: true })(-3), shotDiffs)),
    fill: getDiffColor(-4)
  }]
  return _.filter(dataObject => _.get('y', dataObject) > 0, data)
}

const ThinDonut = props => {
  const { game, width, handicapComparison, style } = props
  const pieHeight = width * 0.6

  const shotDiffs = _.flow(
    _.get('game'),
    _.get(handicapComparison ? 'toCh' : 'toPar')
  )(game)

  const data = calculateData(shotDiffs)

  const scale = 0.85
  const center = pieHeight / 2
  const innerRadius = center * scale
  const donutWidth = (pieHeight - (innerRadius * 2)) / 2
  const leftPoint = `${donutWidth},${center}`
  const rightPoint = `${pieHeight - (donutWidth)},${center}`
  const shots = _.get('game.gameShots', game)
  const points = _.get('game.gamePoints', game)
  const smallTextSize = 14
  const bigNumberSize = 54

  return (
    <div style={style}>
      <svg width={pieHeight} height={pieHeight}>
        <path
          d={`M${leftPoint} A${innerRadius},${innerRadius} 0 0,0 ${rightPoint}`}
          fill='#f6f6f6'
        />
        <VictoryPie
          standalone={false}
          height={pieHeight}
          width={pieHeight}
          labelRadius={0.3 * pieHeight}
          padding={2}
          style={{
            labels: { fill: 'transparent' },
            data: { fill: (d) => d.fill }
          }}
          innerRadius={innerRadius}
          data={data}
        />
        <text
          fill={colors.primaryDarkGreen}
          fontSize={`${bigNumberSize}`}
          x={center}
          y={center - (smallTextSize + smallTextSize)}
          height={bigNumberSize}
          dy={0}
          textAnchor='middle'
        >
          {points}
        </text>
        <text
          fill={colors.lightBlue}
          fontSize={`${smallTextSize}`}
          x={center}
          y={(center) - smallTextSize}
          height={smallTextSize}
          dy={0}
          textAnchor='middle'
        >
          points
        </text>
        <text
          fill={colors.primaryDarkGreen}
          fontSize={`${bigNumberSize}`}
          x={center}
          y={(center) + bigNumberSize}
          height={bigNumberSize}
          dy={0}
          textAnchor='middle'
        >
          {shots}
        </text>
        <text
          fill={colors.lightBlue}
          fontSize={`${smallTextSize}`}
          x={center}
          y={center + smallTextSize + bigNumberSize}
          height={smallTextSize}
          dy={0}
          textAnchor='middle'
        >
          shots
        </text>
      </svg>
    </div>
  )
}

export default ThinDonut
